// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"2d49c741","297":"229c9c46"}[chunkId] + ".chunk.css";
};